// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3ReeY","topBottomGutter":"Layout_topBottomGutter__BQJkR"};